import {
    ArrowDownIcon,
    CalendarIcon,
    LockIcon,
    SearchIcon,
    UserIcon,
} from 'lucide-react-native';
import { useState } from 'react';
import { Separator, XStack, YStack } from 'tamagui';

import { DateInput } from '../../components/inputs/DateInput';
import { DollarInput } from '../../components/inputs/DollarInput';
import { Input } from '../../components/inputs/Input';
import { InputTrigger } from '../../components/inputs/InputTrigger';
import { MultilineInput } from '../../components/inputs/MultilineInput';
import { PercentInput } from '../../components/inputs/PercentInput';
import { PhoneNumberInput } from '../../components/inputs/PhoneNumberInput';
import { SSNInput } from '../../components/inputs/SSNInput';
import { Sheet } from '../../components/sheet/Sheet';
import {
    BodyMediumEmphasized,
    BodyMediumRegular,
} from '../../components/text/Typography';

export const Inputs = () => {
    const [showSheet, setShowSheet] = useState(false);
    const [sheetText, setSheetText] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [ssn, setSsn] = useState('');
    const [dollarAmount, setDollarAmount] = useState('');
    const [percentValue, setPercentValue] = useState('');
    const [dateValue, setDateValue] = useState('');

    return (
        <YStack gap={12}>
            <BodyMediumEmphasized>Input (Basic)</BodyMediumEmphasized>
            <Input placeholder="Default" />
            <Input placeholder="Regular font weight" fontWeight="regular" />
            <Input
                placeholder="With right icon"
                fontWeight="regular"
                rightIcon={LockIcon}
            />
            <Input
                placeholder="With left icon"
                fontWeight="regular"
                leftIcon={SearchIcon}
            />
            <Input
                placeholder="With both left and right icons"
                fontWeight="regular"
                leftIcon={UserIcon}
                rightIcon={LockIcon}
            />
            <Input placeholder="Invalid" invalid />
            <Input placeholder="Disabled" disabled />
            <Separator />
            <BodyMediumEmphasized>PhoneNumberInput</BodyMediumEmphasized>
            <PhoneNumberInput
                value={phoneNumber}
                onChangeText={setPhoneNumber}
                placeholder="(123) 456-7890"
            />
            <Separator />
            <BodyMediumEmphasized>SSNInput</BodyMediumEmphasized>
            <SSNInput
                value={ssn}
                onChangeText={setSsn}
                placeholder="123-45-6789"
            />
            <Separator />
            <BodyMediumEmphasized>DollarInput</BodyMediumEmphasized>
            <DollarInput value={dollarAmount} onChangeText={setDollarAmount} />
            <Separator />
            <BodyMediumEmphasized>PercentInput</BodyMediumEmphasized>
            <PercentInput
                value={percentValue}
                onChangeText={setPercentValue}
                placeholder="%"
            />
            <Separator />
            <BodyMediumEmphasized>DateInput</BodyMediumEmphasized>
            <DateInput
                value={dateValue}
                onChangeText={setDateValue}
                placeholder="MM/DD/YYYY"
            />
            <Separator />
            <BodyMediumEmphasized>MultilineInput</BodyMediumEmphasized>
            <MultilineInput placeholder="This is a MultilineInput, sometimes known as a TextArea" />
            <MultilineInput
                label="I am a label"
                placeholder="It can also have a label"
            />
            <MultilineInput
                numberOfLines={4}
                placeholder="This one is disabled -- this component is a small extension of the main Input component, so it can work with the same props"
                disabled
            />
            <Separator />
            <BodyMediumEmphasized>
                InputTrigger -- looks like an input, but opens something on
                press
            </BodyMediumEmphasized>
            <InputTrigger
                onTrigger={() => {
                    setSheetText('You pressed the first input, nice.');
                    setShowSheet(true);
                }}
                icon={ArrowDownIcon}
                placeholder="Press me to do something"
            />
            <InputTrigger
                onTrigger={() => {
                    setSheetText('You pressed the second input, cool.');
                    setShowSheet(true);
                }}
                icon={CalendarIcon}
                placeholder="Press me to do something else"
            />
            <Sheet
                isOpen={showSheet}
                onClose={() => {
                    setShowSheet(false);
                    setSheetText('');
                }}
                showCloseButton={true}
            >
                <XStack
                    height={200}
                    alignItems="center"
                    justifyContent="center"
                >
                    <BodyMediumRegular>{sheetText}</BodyMediumRegular>
                </XStack>
            </Sheet>
        </YStack>
    );
};
